import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MultilineTextCellComponent } from './multiline-text-cell.component';

@Component({
  selector: 'app-nowrap-multiline-text-cell',
  templateUrl: './multiline-text-cell.component.html',
  styleUrls: ['./multiline-text-cell.component.scss'],
  styles: [':host .multiline-cell ul li { white-space: nowrap !important; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NoWrapMultilineTextCellComponent extends MultilineTextCellComponent {}
